/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import login_logo from "../../../images/loginlogo.png";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  InputLabel,
  Input,
  InputAdornment,
  IconButton,
  Button,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Signuptwo.css";
import {
  userSignupApi,
  fetchUserType,
  fetchVendorSubTypeList,
} from "../../../Services/Signup/SignupApi/SignupApi";
import { toast } from "react-toastify"; // Import Toast components
import "react-toastify/dist/ReactToastify.css"; // Import styles for toast notifications
import { State, City } from "country-state-city";
import HorizontalLinearStepper from "../../Stepper/Stepper";
import { removeUnderScore } from "../../../Utils/LetterCase";

function SignuptwoComp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const location = useLocation();
  const formData = location.state || {};
  const [statesUS, setStatesUS] = useState([]);
  const [cities, setCities] = useState([]);
  const [fileName, setFileName] = useState("");
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const usertype = useSelector((state) => state.fetchUserType.data);
  const realtorRoleId =
    usertype?.data?.find((data) => data?.role_name === "Realtor")?.id || null;

  const vendorRoleId =
    usertype?.data?.find((data) => data?.role_name === "Vendor")?.id || null;
  const [userRole, setUserRole] = useState("");
  const [selectedVendor, setSelectedVendor] = useState("");

  const vendorMaster = {
    // health: "Health",
    // education: "Education",
    local_vendor: "Local Vendor",
    // community_expert: "Community Expert",
  };

  useEffect(() => {
    if (formData?.userType === realtorRoleId) setUserRole("Realtor");
    if (formData?.userType === vendorRoleId) setUserRole("Vendor");
  }, [formData?.userType, realtorRoleId, vendorRoleId]);

  const [formValues, setFormValues] = useState({
    address: "",
    building: "",
    state: "",
    city: "",
    zipcode: "",
    newPassword: "",
    confirmPassword: "",
    termsAccepted: false,
    // Add new fields
    brokerageName: "",
    realEstateWebsite: "",
    brokerageLogo: null,
    //Added new fields for vendor
    sub_vendor: "",
  });

  const vendor =
    useSelector((state) => state.vendorSubtype.vendorSubtypes) || {};
  const subVendors = vendor || [];
  const loading = useSelector((state) => state.vendorSubtype.loading);
  const error = useSelector((state) => state.vendorSubtype.error);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setFormValues((prevValues) => ({
        ...prevValues,
        brokerageLogo: file,
      }));

      setFileName(file.name);
    }
  };

  useEffect(() => {
    // Check localStorage
    const stepOneComplete = localStorage.getItem("signupStepOneComplete");

    if (!stepOneComplete) {
      navigate("/signupone"); // Redirect to first step
    }
  }, [navigate]);

  // Fetch all states when the component mounts
  useEffect(() => {
    const fetchedStates = State.getStatesOfCountry("US"); // 'US' is the country code for United States
    setStatesUS(fetchedStates);
  }, []);

  useEffect(() => {
    dispatch(fetchUserType());
  }, [dispatch]);

  useEffect(() => {
    const savedData = localStorage.getItem("signupTwoFormData");
    if (savedData) {
      setFormValues(JSON.parse(savedData));
    }
  }, []);

  useEffect(() => {
    const savedFormData = localStorage.getItem("signupTwoFormData");
    const currentFormData = JSON.stringify(formValues);

    if (savedFormData !== currentFormData) {
      localStorage.setItem("signupTwoFormData", currentFormData);
    }
  }, [formValues]);

  const vendorHandleChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedVendor(selectedValue);
    dispatch(fetchVendorSubTypeList({ vendor_master_name: selectedValue }));
  };

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    let updatedValue = type === "checkbox" ? checked : value;

    if (name === "zipcode") {
      updatedValue = value.replace(/\D/g, "").slice(0, 5);
    }

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: updatedValue,
    }));

    if (name === "state") {
      const fetchedCities = City.getCitiesOfState("US", value); // Fetch cities for selected state
      setCities(fetchedCities);
      setFormValues((prevValues) => ({ ...prevValues, city: "" })); // Reset city value
    }
  };

  // Extract validation helpers
  const validatePassword = (password) => {
    const pattern =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return pattern.test(password);
  };

  const validateWebsiteUrl = (url) => {
    const pattern = /^https?:\/\/\S+$/;
    return pattern.test(url);
  };

  // Simplified validation function
  const validateForm = () => {
    const errors = {};

    // Required field validation
    const requiredFields = {
      address: "Address",
      state: "State",
      zipcode: "Zipcode",
      newPassword: "Password",
    };

    Object.entries(requiredFields).forEach(([field, label]) => {
      if (!formValues[field]?.trim()) {
        errors[field] = `${label} is required.`;
      }
    });

    // Password validation
    if (formValues.newPassword && !validatePassword(formValues.newPassword)) {
      errors.newPassword =
        "Password must contain at least 8 characters, including uppercase, lowercase, numerals, and symbols.";
    }

    // Password match validation
    if (formValues.newPassword !== formValues.confirmPassword) {
      errors.confirmPassword = "Passwords do not match.";
    }

    // Terms validation
    if (!formValues.termsAccepted) {
      errors.termsAccepted = "You must accept the terms and conditions.";
    }

    // Realtor-specific validation
    if (userRole === "Realtor") {
      if (!formValues.brokerageName?.trim()) {
        errors.brokerageName = "Brokerage Name is required.";
      }
      if (!formValues.realEstateWebsite?.trim()) {
        errors.realEstateWebsite = "Real Estate Website is required.";
      } else if (!validateWebsiteUrl(formValues.realEstateWebsite)) {
        errors.realEstateWebsite =
          "Please enter a valid website URL starting with http:// or https://";
      }
      if (!formValues.brokerageLogo) {
        errors.brokerageLogo = "Brokerage Logo is required.";
      }
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      Object.values(errors).forEach((error) => {
        toast.error(error);
      });
      return;
    }
    try {
      const formDataToSend = new FormData();

      formDataToSend.append("role_id", formData?.userType);
      formDataToSend.append("first_name", formData?.firstName || "");
      formDataToSend.append("last_name", formData?.lastName || "");
      formDataToSend.append("email", formData?.email || "");
      formDataToSend.append("password", formValues.newPassword || "");
      formDataToSend.append("phone_number", formData?.phoneNumber || "");
      formDataToSend.append("address", formValues.address || "");
      formDataToSend.append("bldg_suite_unit", formValues.building || "");
      formDataToSend.append("zipcode", formValues.zipcode || "");
      formDataToSend.append("city", formValues.city || "");
      formDataToSend.append("state", formValues.state || "");

      if (userRole === "Vendor") {
        formDataToSend.append("sub_vendor", formValues.sub_vendor || "");
        formDataToSend.append(
          "real_estate_website_url",
          formValues.realEstateWebsite || ""
        );
        formDataToSend.append("brokerage_name", formValues.brokerageName || "");
      }

      if (formData?.image instanceof File) {
        formDataToSend.append("image", formData.image);
      }
      if (userRole === "Realtor") {
        formDataToSend.append("brokerage_name", formValues.brokerageName || "");
        formDataToSend.append(
          "real_estate_website_url",
          formValues.realEstateWebsite || ""
        );

        if (formValues.brokerageLogo instanceof File) {
          formDataToSend.append("brokerage_logo", formValues.brokerageLogo);
        }
      }

      if (formData?.image instanceof File) {
        formDataToSend.append("image", formData.image);
      }
      const response = await dispatch(userSignupApi(formDataToSend)).unwrap();

      if (response?.status === 200) {
        toast.success("Registration successfull !");
        localStorage.setItem("signupStepTwoComplete", "true");
        setTimeout(() => {
          navigate("/email-verified");
          localStorage.removeItem("signupFormData");
          localStorage.removeItem("signupStepOneComplete");
          localStorage.removeItem("signupTwoFormData");
        }, 300);
      }
    } catch (err) {
      const errorMessage =
        err.response?.data?.message ||
        "Registration failed: Invalid Details or already registered!";
      toast.error(errorMessage); // Display a more specific error message
    }
  };

  const handleLogingroute = () => {
    navigate("/login");
  };

  return (
    <>
      <section className="login-page-one signuptwo-blk">
        <div className="container-fluid p-0 m-0">
          <div className="row m-0 loginpage">
            <div className="col-md-6 signuptwo">
              <div className="login-right-block logo-left-block mb-4">
                <div className="login-logoimg text-center">
                  <img
                    src={login_logo}
                    alt="login-logo"
                    className="login_logo_img"
                  ></img>
                </div>
              </div>
              <div className="banner-contents">
                <div className="banner-image email-verify-blk">
                  {/* <img src={banner_img} alt="banner-image"></img> */}
                  <div className="text-overlay">
                    <h5>Let's Setup Your Operating Agreement</h5>
                    <p>
                      Elevate your business insights with precision. Log in to
                      discover and refine your Ideal Customer Profiles
                      effortlessly.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 signuptwo-col login-cols-block">
              <div className="login-right-block desktop-view">
                <div className="login-logoimg text-center">
                  <Link to="/">
                    <img
                      src={login_logo}
                      alt="login-logo"
                      className="login_logo_img"
                    />
                  </Link>
                </div>
                <div className="stepper  mb-4 d-flex justify-content-between align-items-center">
                  <HorizontalLinearStepper activeStepProp={1} />
                </div>
              </div>
              <div className="stepper stepper-responsive mb-3 d-flex justify-content-between align-items-center">
                <HorizontalLinearStepper activeStepProp={1} />
              </div>
              <div className="login-page-area">
                <div className="login-information log-in">
                  <div className="form-login text-left">
                    {userRole === "Realtor" ? (
                      <>
                        <div className="mb-4">
                          <InputLabel htmlFor="brokerageName">
                            Brokerage Name<span>*</span>
                          </InputLabel>
                          <Input
                            className="address-input"
                            id="brokerageName"
                            type="text"
                            name="brokerageName"
                            placeholder="Enter Brokerage Name"
                            value={formValues.brokerageName}
                            onChange={handleChange}
                          />
                          {errors.brokerageName && (
                            <p className="error-text">{errors.brokerageName}</p>
                          )}
                        </div>
                        <div className="mb-4">
                          <InputLabel htmlFor="realEstateWebsite">
                            Real Estate Website(URL)<span>*</span>
                          </InputLabel>
                          <Input
                            className="address-input"
                            id="realEstateWebsite"
                            type="text"
                            name="realEstateWebsite"
                            placeholder="https://www.example.com"
                            value={formValues.realEstateWebsite}
                            onChange={handleChange}
                          />
                          {errors.realEstateWebsite && (
                            <p className="error-text">
                              {errors.realEstateWebsite}
                            </p>
                          )}
                        </div>
                        <div className="mb-4">
                          <div className="file-upload">
                            <label htmlFor="fileInput">
                              Brokerage Logo <span>*</span>
                            </label>
                            <div className="input-container">
                              <input
                                type="file"
                                id="fileInput"
                                name="brokerageLogo"
                                onChange={handleFileChange}
                                accept="image/*"
                              />
                              <span className="custom-file-label">
                                <span>Choose File</span>
                                <i
                                  className="fa fa-paperclip"
                                  aria-hidden="true"
                                ></i>
                              </span>
                            </div>

                            {/* Display the selected file name */}
                            {fileName && (
                              <p className="files-name">
                                Selected File: {fileName}
                              </p>
                            )}

                            {/* Display error message if any */}
                            {errors.brokerageLogo && (
                              <span className="error-text">
                                {errors.brokerageLogo}
                              </span>
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      userRole === "Vendor" && (
                        <>
                          <div className="mb-4">
                            <InputLabel htmlFor="brokerageName">
                              Business Name<span>*</span>
                            </InputLabel>
                            <Input
                              className="address-input"
                              id="brokerageName"
                              type="text"
                              name="brokerageName"
                              placeholder="Enter Business Name"
                              value={formValues.brokerageName}
                              onChange={handleChange}
                            />
                            {errors.brokerageName && (
                              <p className="error-text">
                                {errors.brokerageName}
                              </p>
                            )}
                          </div>
                          <div className="mb-4">
                            <InputLabel htmlFor="vendor-type-select">
                              Vendor Type <span>*</span>
                            </InputLabel>
                            <select
                              className="user-type-dropdown"
                              id="vendor-type-select"
                              name="vendorType"
                              value={selectedVendor}
                              onChange={vendorHandleChange}
                            >
                              <option value="" disabled>
                                Select Vendor Type
                              </option>
                              {Object.entries(vendorMaster).map(
                                ([key, label]) => (
                                  <option key={key} value={key}>
                                    {label}
                                  </option>
                                )
                              )}
                            </select>
                          </div>

                          {/* Subcategory Dropdown */}
                          {selectedVendor && (
                            <div className="mb-4">
                              <InputLabel htmlFor="sub-vendor-type-select">
                                Subcategory <span>*</span>
                              </InputLabel>
                              <select
                                className="user-type-dropdown"
                                id="sub-vendor-type-select"
                                name="sub_vendor"
                                value={formValues.sub_vendor}
                                onChange={(e) => {
                                  const selectedValue = e.target.value;
                                  setFormValues((prev) => ({
                                    ...prev,
                                    sub_vendor: selectedValue,
                                  }));
                                }}
                                disabled={loading || error}
                                // Disable dropdown during loading/error
                              >
                                <option value="" disabled>
                                  {loading
                                    ? "Loading..."
                                    : error
                                    ? "Error fetching data"
                                    : "Select Subcategory"}
                                </option>
                                {!loading &&
                                  !error &&
                                  subVendors.length > 0 &&
                                  subVendors.map((sub) => (
                                    <option key={sub.id} value={sub.id}>
                                      {removeUnderScore(sub.sub_vendor_type)}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          )}
                          <div className="mb-4">
                            <InputLabel htmlFor="realEstateWebsite">
                              Real Estate Website(URL)<span>*</span>
                            </InputLabel>
                            <Input
                              className="address-input"
                              id="realEstateWebsite"
                              type="text"
                              name="realEstateWebsite"
                              placeholder="https://www.example.com"
                              value={formValues.realEstateWebsite}
                              onChange={handleChange}
                            />
                            {errors.realEstateWebsite && (
                              <p className="error-text">
                                {errors.realEstateWebsite}
                              </p>
                            )}
                          </div>
                        </>
                      )
                    )}

                    <div className="mb-4 mt-3">
                      <InputLabel htmlFor="address">
                        Address<span>*</span>
                      </InputLabel>
                      <Input
                        className="address-input"
                        id="address"
                        type="text"
                        name="address"
                        placeholder="Enter Address"
                        value={formValues.address}
                        onChange={handleChange}
                      />
                      {errors.address && (
                        <p className="error-text">{errors.address}</p>
                      )}
                    </div>

                    <div className="mb-4">
                      <InputLabel htmlFor="building">
                        Building, Suite or Unit
                      </InputLabel>
                      <Input
                        className="building-input"
                        id="building"
                        type="text"
                        name="building"
                        placeholder="Enter Building, Suite or Unit"
                        value={formValues.building}
                        onChange={handleChange}
                      />
                      {errors.building && (
                        <p className="error-text">{errors.building}</p>
                      )}
                    </div>
                    <div className="mb-4">
                      <InputLabel htmlFor="user-type-select">
                        State<span>*</span>
                      </InputLabel>
                      <select
                        className="user-type-dropdown"
                        id="user-type-selectt"
                        defaultValue=""
                        name="state"
                        value={formValues.state}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Select State
                        </option>
                        {statesUS.map((state) => (
                          <option key={state.isoCode} value={state.isoCode}>
                            {state.name}
                          </option>
                        ))}
                      </select>
                      {errors.state && (
                        <p className="error-text">{errors.state}</p>
                      )}
                    </div>
                    <div className="mb-4">
                      <div className="city-zipcode-container">
                        <div className="city-div">
                          <InputLabel htmlFor="city" className="mb-0">
                            City
                          </InputLabel>
                          <select
                            className="user-type-dropdown"
                            id="city"
                            name="city"
                            value={formValues.city}
                            onChange={handleChange}
                          >
                            <option value="" disabled>
                              Select City
                            </option>
                            {cities.map((city) => (
                              <option key={city.name} value={city.name}>
                                {city.name}
                              </option>
                            ))}
                          </select>
                          {errors.city && (
                            <p className="error-text">{errors.city}</p>
                          )}
                        </div>
                        <div className="zipcode-div">
                          <InputLabel htmlFor="zipcode" className="mb-0">
                            Zip Code<span>*</span>
                          </InputLabel>
                          <Input
                            className="zipcode-input"
                            id="zipcode"
                            type="text"
                            name="zipcode"
                            placeholder="Enter Zip Code"
                            value={formValues.zipcode}
                            onChange={handleChange}
                          />
                          {errors.zipcode && (
                            <p className="error-text">{errors.zipcode}</p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="mb-4">
                      <InputLabel htmlFor="new-password">
                        Password <span>*</span>
                      </InputLabel>
                      <Input
                        className="password-input-box"
                        id="new-password"
                        placeholder="New Password"
                        name="newPassword"
                        type={showNewPassword ? "text" : "password"}
                        value={formValues.newPassword}
                        onChange={handleChange}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                showNewPassword
                                  ? "hide the password"
                                  : "display the password"
                              }
                              onClick={() =>
                                setShowNewPassword((prev) => !prev)
                              }
                              onMouseDown={(event) => event.preventDefault()}
                            >
                              {showNewPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      {errors.newPassword && (
                        <p className="error-text">{errors.newPassword}</p>
                      )}
                      <div className="pw-text-bottom">
                        Password should be the combination of{" "}
                        <span>
                          Uppercase & Lowercase Letters, Numerals and Symbols
                        </span>
                        .
                      </div>
                    </div>

                    <div className="mb-4">
                      <InputLabel htmlFor="confirm-password">
                        Confirm Password <span>*</span>
                      </InputLabel>
                      <Input
                        className="password-input-box"
                        id="confirm-password"
                        placeholder="Confirm Password"
                        name="confirmPassword"
                        type={showConfirmPassword ? "text" : "password"}
                        value={formValues.confirmPassword}
                        onChange={handleChange}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                showConfirmPassword
                                  ? "hide the password"
                                  : "display the password"
                              }
                              onClick={() =>
                                setShowConfirmPassword((prev) => !prev)
                              }
                              onMouseDown={(event) => event.preventDefault()}
                            >
                              {showConfirmPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      {errors.confirmPassword && (
                        <p className="error-text">{errors.confirmPassword}</p>
                      )}
                    </div>

                    <div className="mb-4 checkbox d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-start">
                        <div>
                          <Checkbox
                            {...label}
                            className="check-box pt-0"
                            checked={formValues.termsAccepted}
                            onChange={handleChange}
                            name="termsAccepted"
                          />
                        </div>
                        <span className="password-text">
                          By clicking Create an account, I agree that I have
                          read and accepted the <span>Terms of Use</span> and{" "}
                          <span>Privacy Policy</span>.
                        </span>
                      </div>
                    </div>
                    <div className="btn-orange">
                      <Button onClick={handleSubmit}>Create an Account</Button>
                    </div>
                    <div className="lower-signup-text text-center">
                      <p>
                        Already have an account?{" "}
                        <a href="" onClick={handleLogingroute}>
                          Log In
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ToastContainer for toast notifications */}
    </>
  );
}

export default SignuptwoComp;
